module.exports = __webpack_public_path__ + "static/media/S (6).d99c16e5.jpg";